import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TableCell, TableRow, Checkbox, Link, Tooltip } from '@mui/material';
import { ThemedTypography } from 'components/common/CommonStyles';
import PropTypes from 'prop-types';
import FinancedOffersAssetInformationListItemComponent from './FinancedOffersAssetInformationListItemComponent';

export const FinancedOffersAssetItemComponentV2 = ({
  t,
  asset,
  offerId,
  offerSiteId,
  openOfferAsset,
  selectAssetsForContractGeneration,
  selected
}) => {
  return (
    <>
      <TableRow key={asset.id}>
        <TableCell>
          <Checkbox
            checked={selected}
            onChange={selectAssetsForContractGeneration(offerId, offerSiteId, asset.id, null)}
            disabled={
              !asset.assetsAdditionalInformation.some(x => !x.contractNumber) ? true : asset.canGenerateContract === true ? false : true
            }
          />
        </TableCell>
        <Tooltip title={asset.name}>
          <TableCell>
            <Link style={{ cursor: 'pointer' }} onClick={openOfferAsset(offerId, offerSiteId, asset.id)}>
              <ThemedTypography color='info'> {asset.name}</ThemedTypography>
            </Link>
          </TableCell>
        </Tooltip>
        <TableCell>
          <ThemedTypography color='info' weight='bold'>{`${t('NUMBER', { number: asset.totalValue })} ${asset.currency}`}</ThemedTypography>
        </TableCell>
        <TableCell>
          <ThemedTypography color='info'>{asset.dealerName}</ThemedTypography>
        </TableCell>
      </TableRow>
      <TableRow key={asset.id}>
        <TableCell colSpan={4}>
          <FinancedOffersAssetInformationListItemComponent
            asset={asset}
            offerId={offerId}
            offerSiteId={offerSiteId}
            assetId={asset.id}
            selectAssetsForContractGeneration={selectAssetsForContractGeneration}
            canGenerateContract={asset.canGenerateContract}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

FinancedOffersAssetItemComponentV2.propTypes = {
  asset: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  offerId: PropTypes.number.isRequired,
  offerSiteId: PropTypes.number.isRequired,
  openOfferAsset: PropTypes.func.isRequired,
  selectAssetsForContractGeneration: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};

export default compose(withTranslation())(FinancedOffersAssetItemComponentV2);
